import { useState } from "react"
import { router } from "@inertiajs/react"
import { StepShell } from "../components/StepShell"
import { DynamicList } from "../components/DynamicList"
import { VoiceField } from "@/components/planning/client-only/VoiceField"
import { GuideMeCta } from "@/components/planning/client-only/GuideMeCta"

function defaultRows(saved) {
  if (saved && saved.length > 0) return saved
  return Array.from({ length: 2 }, () => ({ text: "" }))
}

export function Ministry({ data }) {
  const [rows, setRows] = useState(() => defaultRows(data.annualPlan.ministryGoals))
  const [processing, setProcessing] = useState(false)

  const submit = () => {
    setProcessing(true)
    router.patch(
      "/app/plan/intake",
      { step: "ministry", ministry_goals: rows, advance: "1" },
      { preserveScroll: true, onFinish: () => setProcessing(false) },
    )
  }

  return (
    <StepShell
      title="Ministry in Business"
      subtitle="1–5 ways your work is (or will be) ministry — goals, initiatives, or projects where your business serves God and people beyond profit."
      onNext={submit}
      processing={processing}
    >
      <GuideMeCta
        section="ministry"
        onInsert={(bullets) =>
          setRows(bullets.slice(0, 5).map((text) => ({ text })))
        }
        title="Ministry in business isn't always obvious."
        subtitle="Talk it through with an AI coach to uncover where your work is already (or could be) kingdom work."
      />
      <DynamicList
        items={rows}
        onChange={setRows}
        min={1}
        max={5}
        newItem={() => ({ text: "" })}
        addLabel="Add another"
        render={(item, update) => (
          <VoiceField
            value={item.text}
            onChange={(v) => update("text", v)}
            placeholder="e.g., Host a monthly Christian business-owner breakfast"
            rows={2}
            ariaLabel="Ministry goal"
          />
        )}
      />
    </StepShell>
  )
}
